module.exports = __webpack_public_path__ + "img/1-14-7.d5eea67d.png";